import React, { StatelessComponent } from 'react';
import { AVATAR_DEFAULT } from '../utils/classes';
import { Focusable } from '../Focusable';
import './_styles.scss';

export interface IAvatarProps {
  /**
   * Url from to give the image.
   */
  height?: number;
  /**
   * Widht of the circle in porcent
   */
  width?: number;
  /**
   * url from image
   */
  url?: string;
  /**
   * callback to  executen then click the Avatar
   */
  urlImg?: string;
  /**
   * url from image avatar
   */
  onClick?: () => void;
}

export const Avatar: StatelessComponent<IAvatarProps> = props => {
    const {
        height,
        width,
        url,
        urlImg,
        onClick,
    } = props;
    const disableRight = { "data-sn-right": '' };
    return (
        <div style={{ width, height }} className={AVATAR_DEFAULT}>
            <Focusable onClick={onClick} className="focusable" blockedRight = {disableRight} >
                <img
                    src={ urlImg !== undefined &&
                        urlImg !== null &&
                        urlImg !== '' ? urlImg : url }
                    alt="avatarImage"
                />
            </Focusable>
        </div>
    );
};
Avatar.defaultProps = {
  height: 40,
  width: 40,
  url: 'http://www.clarovideo.com/webclient/sk_core/images/placeholder_avatar.png'
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Avatar/index.tsx